import { connectionData, endpoint } from "./apiConnection";

export const dataCuotasPadres = async idAlumno => connectionData(endpoint,'cuotas/meses/'+idAlumno,'GET');
export const toMakeLinkCuota = async ( idAlumno , mes ) => connectionData(endpoint,`cuota/${idAlumno}/${mes}`,'GET');
